var exports = {
  "p": "ChannelWelcomeSection.module__channelIcon___Z25tYW",
  "kL": "ChannelWelcomeSection.module__container___Z25tYW",
  "R_": "ChannelWelcomeSection.module__heading___Z25tYW",
  "h_": "ChannelWelcomeSection.module__description___Z25tYW",
  "RK": "ChannelWelcomeSection.module__iconSize___Z25tYW",
};

module.exports = exports;
